import ready from '../../src/js/utilities/ready';

const cardCarouselInit = () => {
	const cardCarousel = document.querySelectorAll('.js-card-carousel');
	cardCarousel.forEach((carousel) => {
		const cards = carousel.querySelectorAll('.card-carousel__slide');
		for (let i = 0; i < cards.length; i++) {
			cards[i].onclick = function () {
				if (this.classList.contains('card-active')) {
					hideCards();
				} else {
					showCard(this);
				}
			};
		}

		function showCard(elem) {
			hideCards();
			elem.classList.add('card-active');
			elem.setAttribute('aria-expanded', true);
		}

		function hideCards() {
			for (let i = 0; i < cards.length; i++) {
				cards[i].classList.remove('card-active');
				cards[i].setAttribute('aria-expanded', false);
			}
		}
	});
};

ready(cardCarouselInit);
